import React from 'react';
import { SizeMe } from 'react-sizeme';
import {
  withPublicLink,
  AuthorisationConsumer,
  CreditsConsumer
} from '@shootsta/common-react';
import { ApolloConsumer } from 'react-apollo';
import CoreLayoutWrapper from '../components/CoreLayoutWrapper';

function CoreLayout(props: any) {
  return (
    <ApolloConsumer>
      {(apolloClient) => (
        <AuthorisationConsumer>
          {({
            selectedOrganisation: {
              imageUrl,
              name,
              package: organisationPackage,
              organisationId,
              preferences,
              clientType
            }
          }) => (
            <CreditsConsumer>
              {({ state: { canCreateOrSubmitProject } }) => (
                <SizeMe>
                  {({ size: { width } = { width: 0 } }) => (
                    <CoreLayoutWrapper
                      shootstaAI={preferences?.shootstaAI || false}
                      logoUrl={imageUrl}
                      organisationName={name}
                      organisationPackage={organisationPackage}
                      apolloClient={apolloClient}
                      organisationId={organisationId}
                      width={width}
                      canCreateOrSubmitProject={canCreateOrSubmitProject}
                      clientType={clientType}
                      {...props}
                    />
                  )}
                </SizeMe>
              )}
            </CreditsConsumer>
          )}
        </AuthorisationConsumer>
      )}
    </ApolloConsumer>
  );
}
export default withPublicLink(CoreLayout);
